import { useTranslation } from 'react-i18next'

import { useNavigate } from '@lib/react-router-dom'

import { useAccountInfo } from '@context/AccountInfoContext/AccountInfoContext.Provider'
import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

import { CommonPaths } from '@utils/path'

import {
  isMT4PlatformType,
  isMT5PlatformType,
  isTMTPlatformType,
  isTradingViewPlatformType,
} from '@model/PlatformTypeEnum'

type Variant = 'default' | 'informational'

interface Props {
  variant?: Variant
}

export const CampaignAccountConfirmationModal: BaseModalType<Props> = (props) => {
  const { close, variant = 'default' } = props
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { accountInfo } = useAccountInfo()
  const isInformational = variant === 'informational'

  const handleCreate = () => {
    close()
    navigate(CommonPaths.NewLiveTradingAccount + '?campaign=true')
  }

  const tradingAccountPlatforms = accountInfo.filter(
    (info) =>
      isMT4PlatformType(info.platform.id) ||
      isMT5PlatformType(info.platform.id) ||
      isTMTPlatformType(info.platform.id) ||
      isTradingViewPlatformType(info.platform.id)
  )
  const isCampaignCreationDisabled =
    tradingAccountPlatforms.length > 0 &&
    tradingAccountPlatforms.every((info) => info.maxAccountsAllowed === 0)

  return (
    <Modal>
      <Modal.Header>{t('Campaign Account')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          {t(
            'Campaigns.A Campaign Account is linked to a specific campaign and limited to one per user',
            { days: 30 }
          )}{' '}
          {!isInformational && t('Campaigns.Do you want to create a Campaign Account now')}
        </Modal.Body.Text>
      </Modal.Body>

      <Modal.Footer>
        {!isInformational && (
          <Modal.Footer.Secondary onClick={close}>{t('Not now')}</Modal.Footer.Secondary>
        )}

        <Modal.Footer.Primary
          onClick={isInformational ? close : handleCreate}
          disabled={isCampaignCreationDisabled}
        >
          {t(isInformational ? 'Got It' : 'Create')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
